import { render, staticRenderFns } from "./SalesNotes.vue?vue&type=template&id=47c75c69&scoped=true&"
import script from "./SalesNotes.vue?vue&type=script&lang=js&"
export * from "./SalesNotes.vue?vue&type=script&lang=js&"
import style0 from "./SalesNotes.vue?vue&type=style&index=0&id=47c75c69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c75c69",
  null
  
)

export default component.exports